import cx from 'classnames';
import dateFnsFormat from 'date-fns/format';
import * as React from 'react';
import DayPicker, { NavbarElementProps } from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import { defaultDayPickerProps, zhDayPickerProps } from './date-input';
import { RightIcon } from './icon/right-icon';
import { useLang } from './localize-context';
import { LeftIcon } from './icon/left-icon';

type CalendarProps = React.ComponentProps<typeof DayPicker>;

export const Calendar = (props: CalendarProps) => {
  const lang = useLang();

  return (
    <DayPicker
      classNames={classNames}
      className="w-full"
      navbarElement={CalendarNav}
      captionElement={() => null}
      {...(lang === 'zh-sg' ? zhDayPickerProps : defaultDayPickerProps)}
      {...props}
    />
  );
};

const CalendarNav = (props: NavbarElementProps) => {
  return (
    <div className="flex justify-center items-center text-3xl">
      <button
        onClick={() => props.onPreviousClick()}
        aria-label={props.labels.previousMonth}
        className={cx(
          'mr-2',
          props.showPreviousButton ? 'text-blue-400' : 'text-gray-400'
        )}
        disabled={!props.showPreviousButton}
      >
        <LeftIcon className="fill-current" width={48} />
      </button>
      <span>{dateFnsFormat(props.month, 'YYYY/MM')}</span>
      <button
        onClick={() => props.onNextClick()}
        aria-label={props.labels.nextMonth}
        className={cx(
          'ml-2',
          props.showNextButton ? 'text-blue-400' : 'text-gray-400'
        )}
        disabled={!props.showNextButton}
      >
        <RightIcon className="fill-current" width={48} />
      </button>
    </div>
  );
};

const classNames = {
  container: 'DayPicker',
  wrapper: 'DayPicker-wrapper focus:outline-none',
  interactionDisabled: 'DayPicker--interactionDisabled',
  months: 'DayPicker-Months',
  month: 'DayPicker-Month',

  navBar: 'DayPicker-NavBar',
  navButtonPrev: 'DayPicker-NavButton DayPicker-NavButton--prev',
  navButtonNext: 'DayPicker-NavButton DayPicker-NavButton--next',
  navButtonInteractionDisabled: 'DayPicker-NavButton--interactionDisabled',

  caption: 'DayPicker-Caption',
  weekdays: 'DayPicker-Weekdays',
  weekdaysRow: 'DayPicker-WeekdaysRow',
  weekday: 'DayPicker-Weekday',
  body: 'DayPicker-Body',
  week: 'DayPicker-Week',
  weekNumber: 'DayPicker-WeekNumber',
  // day: 'DayPicker-Day w-24 h-24 relative text-left table-cell align-middle',
  day: 'w-24 h-24 relative text-left table-cell align-middle px-2',
  footer: 'DayPicker-Footer',
  todayButton: 'DayPicker-TodayButton',

  // default modifiers
  today: 'today',
  selected: 'selected',
  disabled: 'disabled',
  outside: 'outside',
};
